module.exports = __webpack_public_path__ + "img/1574113172.f9de4558.jpg";